import { makeObservable } from "mobx";

/**
 * Observed decorator
 *
 * Annotates a class as being observed
 *
 * Makes instances of the class observed. Used together with the `@observable`
 * decorator on class properties.
 */
export function observed<T extends { new (...args: any[]): any }>(constructor: T) {
    return class extends constructor {
        constructor(...args: any[]) {
            super(...args);

            makeObservable(this);
        }
    };
}
